import { NavLink } from "react-router-dom";
import { useSettings } from "../../data/content";

function NavLinks() {
  const { navLinks = [] } = useSettings();

  return (
    <>
      {navLinks.map(({ _key, label, href }) => (
        <NavLink
          key={_key}
          to={href}
          // Without `end`, "/" matches every route and stays highlighted.
          end={href === "/"}
          className={({ isActive }) =>
            `px-3 py-1.5 rounded-full font-sans text-sm transition-colors ${
              isActive
                ? "text-text-primary-light dark:text-text-primary-dark font-medium"
                : "text-text-muted-light dark:text-text-muted-dark hover:text-text-primary-light dark:hover:text-text-primary-dark"
            }`
          }
        >
          {label}
        </NavLink>
      ))}
    </>
  );
}

export default NavLinks;
